import {
  Box,
  Button,
  Flex,
  Grid,
  GridItem,
  Spinner,
  Table,
  Tbody,
  Td,
  Tr,
  useToast,
} from "@chakra-ui/react";
import {
  createUser,
  sendEmail,
  createCompany,
  getViaCep,
} from "src/services/api";
import axios, { AxiosError } from "axios";
import { useEffect, useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { AiFillPlusCircle } from "react-icons/ai";
import { HiOutlineTrash } from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import { TextInput } from "src/components/Forms/TextInput";
import { HeaderInfo } from "src/components/HeaderInfo";
import { useGlobal } from "src/contexts/global";
import { Feedback } from "src/components/Feedback/feedback";
import { masked, unMasked } from "src/utils/masked";
import { validateCpfCnpj } from "src/utils/validateDocument";
import { AppsEcosystem } from "./AppsEcosystem";
import bcrypt from "bcryptjs";
import { handleDataDefaultVersionUnique } from "src/utils/versionDefaultUnique";
import { handleDataDefaultVersionGestor } from "src/utils/versionDefaultGestor";
import { IdataVersionComapnie } from "src/Interfaces/dataVersionCompanie";
import { TitleRegisterCompany } from "src/components/HeaderPages/TitleRegisterCompany";
import { LogoNucleo } from "src/components/HeaderPages/LogoNucleo";
import { UserLogged } from "src/components/HeaderPages/UserLogged";
import { ButtonLogout } from "src/components/HeaderPages/ButtonLogout";
import { IRegister } from "src/Interfaces/Register";
import { IAplicativo } from "src/Interfaces/App";
import { IErrorResponse } from "src/Interfaces/Response";
import { HeaderLayout } from "src/layouts/header";

type System = "gestor" | "unique" | null;

export const Creation = () => {
  const { session } = useGlobal();
  const toast = useToast();
  const {
    register,
    setValue,
    handleSubmit,
    formState: { isSubmitting, errors },
  } = useForm<IRegister>({
    shouldFocusError: false,
  });
  const [system, setSystem] = useState<System>(null);
  const navigate = useNavigate();
  const [isOpenModalApp, setIsOpenModalApp] = useState(false);
  const [isOpenModalNewApp, setIsOpenModalNewApp] = useState(false);
  const [apps, setApps] = useState<IAplicativo[]>([]);
  const [tags, setTags] = useState<string[]>([]);
  const [dataVersionDefaultGestor, setDataVersionDefaultGestor] = useState(
    {} as IdataVersionComapnie | undefined
  );
  const [dataVersionDefaultUnique, setDataVersionDefaultUnique] = useState(
    {} as IdataVersionComapnie | undefined
  );

  const [isLoading, setIsLoading] = useState(false);

  //2.01.009 -> HTML convertido em texto
  // Utilizado https://codebeautify.org/minify-html para transformar html em texto
  const baseHtml =
    "<html><head><title>Primeiro Acesso</title><meta charset='utf-8'></head><body style='justify-content:center;align-items:center;background-color:#f7f7f7;margin:0;font-family:Arial,Helvetica,sans-serif'><div><img src='https://www.londrisoftservices.com.br/imagens/institucional/onboarding/email_boas-vindas/images/email_boas-vindas_01.png' width='640' height='80' alt='Londrisoft' style='display:block'> <img src='http://www.londrisoftservices.com.br/imagens/workspace/emails/2021/images/workspace_emails_1o-acesso.png' width='640' height='190' alt='1º Acesso' style='display:block'></div><div><p style='width:512px;margin-top:0;margin-bottom:10px;color:#1e57bf'><strong>Bem-vindo(a), {{responsavel}}!</strong></p><br><p style='margin-top:0;margin-bottom:10px;color:#222'>Agradecemos por aguardar, finalizamos as configurações</p><p style='margin-top:0;margin-bottom:10px;color:#222'>necessária da sua conta, esses são os dados para seu acesso:</p></div><div style='width:615px;height:120px;padding:10px;background:#e5e5e5'><p style='margin-left:5px;margin-top:10px;color:#222'>Empresa:<strong>{{razao}}</strong></p><p style='margin-left:5px;margin-top:0;margin-bottom:10px;color:#222'>CNPJ:<strong>{{cnpjcpf}}</strong></p><p style='margin-left:5px;margin-top:0;margin-bottom:10px;color:#222'>Login:<strong>{{email}}</strong></p></div><div style='width:512px;margin-top:20px'><p style='margin-top:0;margin-bottom:10px;color:#222'><strong>Para a sua segurança, orientamos a troca da senha:</strong></p><a href='{{link}}' target='_blank' style='cursor:pointer'><button style='width:154px;height:46px;background-color:#15b;color:#fff;border:none;border-radius:4px'>Alterar Senha</button></a></div><div style='width:512px;margin-top:20px'><p style='margin-top:0;margin-bottom:10px;color:#222'>Você tem acesso aos seguintes serviços:</p><p style='margin-top:0;margin-bottom:10px;color:#222'>{{aplicativos}}</p></div><div style='margin-top:40px'><p style='margin-top:0;margin-bottom:10px;color:#222'>Em caso de dúvidas envie uma mensagem no<a href='https://londrisoft.com.br' target='_blank' style='color:#00f;cursor:pointer'>&nbsp;nosso site</a></p></div><div style='display:flex;flex-direction:row'><a href='https://londrisoft.com.br/?utm_source=email_workspace&utm_medium=rodape_email&utm_campaign=workspace' target='_blank'><img src='http://www.londrisoftservices.com.br/imagens/workspace/emails/2021/images/londrisoft.png' width='465' height='80' border='0' alt='Londrisoft' style='display:block'></a><a href='https://www.facebook.com/londrisoft' target='_blank'><img src='http://www.londrisoftservices.com.br/imagens/workspace/emails/2021/images/facebook.png' width='35' height='80' border='0' alt='Facebook' style='display:block'></a><a href='https://www.instagram.com/londrisoft/' target='_blank'><img src='http://www.londrisoftservices.com.br/imagens/workspace/emails/2021/images/instagram.png' width='35' height='80' border='0' alt='Instagram' style='display:block'></a><a href='https://br.linkedin.com/company/londrisoft' target='_blank'><img src='http://www.londrisoftservices.com.br/imagens/workspace/emails/2021/images/linkedin.png' width='35' height='80' border='0' alt='LinkedIn' style='display:block'></a><a href='https://www.youtube.com/channel/UCoQWBxPXIDBgubbkb066u0Q' target='_blank'><img src='http://www.londrisoftservices.com.br/imagens/workspace/emails/2021/images/youtube.png' width='35' height='80' border='0' alt='YouTube' style='display:block'></a><img src='http://www.londrisoftservices.com.br/imagens/workspace/emails/2021/images/workspace_emails_09.png' width='35' height='80' alt='' style='display:block'></div></body></html>";

  const handleGetCep = async (cep: string) => {
    try {
      if (cep.length === 9) {
        const verifyCep = cep;
        const responseViaCep = await getViaCep(verifyCep);

        if (responseViaCep.erro) {
          toast({
            title: "CEP Inválido",
            description: "Falha ao buscar o cep, verifique e tente novamente",
            position: "top-right",
            status: "warning",
            isClosable: true,
            containerStyle: {
              fontSize: "14px",
            },
          });
        }

        setValue("estado", responseViaCep.uf);
        setValue("endereco", responseViaCep.logradouro);
        setValue("cidade", responseViaCep.localidade);
        setValue("bairro", responseViaCep.bairro);
        setValue("numero", "");
      }
    } catch (error: any) {
      toast({
        title: "CEP Inválido",
        description: "Falha ao buscar o cep, verifique e tente novamente",
        position: "top-right",
        status: "warning",
        isClosable: true,
        containerStyle: {
          fontSize: "14px",
        },
      });
    }
  };

  const handleSaveCompany: SubmitHandler<IRegister> = async (data) => {
    setIsLoading(true);
    //2.01.009 -> Criado grupos de identificação de aplicativos
    const containGestor = tags.some((item) =>
      item.toUpperCase().includes("GE_")
    );
    const containUnique = tags.some((item) =>
      item.toUpperCase().includes("UN_")
    );

    const isGestorNuvem = tags.some((item) =>
      item.toUpperCase().includes("GE_N")
    );

    //2.01.009 ->
    const versaoDefaultGestor =
      dataVersionDefaultGestor !== undefined
        ? dataVersionDefaultGestor.versao
        : "";

    //2.01.009 ->
    const versaoDefaultUnique =
      dataVersionDefaultUnique !== undefined
        ? dataVersionDefaultUnique.versao
        : "";

    //2.01.009 -> Váriavel responsavel por montar a tag da versão default
    const contentVersaoSistema = `<${containGestor ? "GESTOR" : "UNIQUE"}>${
      containGestor ? versaoDefaultGestor : versaoDefaultUnique
    }<${containGestor ? "GESTOR" : "UNIQUE"}>`;

    try {
      //2.01.009 ->
      //Senha padrão= "ls + 8 primeiros digitos (cpf/cnpj) + minuto + segundo da hora de cadastro

      const minutes = String(new Date().getMinutes()).padStart(2, "0");
      const seconds = String(new Date().getSeconds()).padStart(2, "0");
      const passwordDefault = `ls${unMasked(data.cnpjcpf).slice(
        0,
        8
      )}${minutes}${seconds}`;

      const salt = bcrypt.genSaltSync(10);
      const hashLink = bcrypt
        .hashSync(passwordDefault, salt)
        .replace("/", "")
        .replace("+", "");

      let listAppActived: any = [];
      listAppActived = apps.filter((item) => {
        return item.indAtivar === "S";
      });

      const listApp = JSON.stringify(listAppActived.map((item) => item.nome));

      const finalListApp = `<p>- ${listApp
        .replaceAll("[", "")
        .replaceAll("]", "")
        .replaceAll(/["]/g, "")
        .replaceAll(",", " </p><p>- ")}</p>`;

      //2.01.009 -> altera váriaveis do html
      const newHtml = baseHtml
        .replace("{{razao}}", data.razao)
        .replace("{{cnpjcpf}}", data.cnpjcpf)
        .replace("{{email}}", data.email)
        .replace("{{responsavel}}", data.responsavel)
        .replace("{{aplicativos}}", finalListApp)
        .replace(
          "{{link}}",
          `https://workspace.londrisoft.com.br/recovery?hash=${hashLink}`
        );
      // .replace("{{razao}}", "teste")
      // .replace("{{cnpjcpf}}", "04361421000107")
      // .replace("{{email}}", "wesley.londrisoft@gmail.com")
      // .replace("{{responsavel}}", "asdfasdf")
      // .replace("{{aplicativos}}", finalListApp)
      // .replace(
      //   "{{link}}",
      //   `https://workspace.londrisoft.com.br/recovery?hash=$2b$10$J6aK8XhFw4D576AT5XOD.hH5eOe.1Z7JoITRwib1iDk9rusUlJqe`
      // );
      const payloadCompany = {
        ...data,
        aplicativos: `|${containGestor ? "GESTOR|" : ""}${
          containUnique ? "UNIQUE|" : ""
        }${tags.join("|")}|`,
        indHospedagem: isGestorNuvem ? "1" : "0",
        planoGestorId: Number(data.planoGestorId || "0"),
        planoUniqueId: Number(data.planoUniqueId || "0"),
        fone: unMasked(data.fone),
        cep: unMasked(data.cep),
        cnpjcpf: unMasked(data.cnpjcpf),
        // indParceiro: data.indparceiro,
        isRegisterCompany: false,
        versaoSistema:
          containGestor || containUnique ? contentVersaoSistema : "",
      };

      const payloadUser = {
        aplicativos: `|${containGestor ? "GESTOR|" : ""}${
          containUnique ? "UNIQUE|" : ""
        }${tags.join("|")}|`,
        name: data.responsavel,
        password: passwordDefault,
        email: data.email,
        CompanyCnpjCpf: unMasked(data.cnpjcpf),
        status: isGestorNuvem ? false : true,
        type: isGestorNuvem ? 1 : 0,
        perfil: 0,
        perfilId: 1,
        tokenRememberPassword: hashLink,
        isRegisterCompany: true,
      };

      const payloadEmail = {
        Email: data.email,
        Base64: newHtml,
      };

      await createCompany(payloadCompany, session.token)
        .then(() => {
          createUser(payloadUser, unMasked(data.cnpjcpf))
            .then(() => {
              if ((listApp.includes("Contador") && listApp.includes("Simplaz")) === false) {
                sendEmail(payloadEmail, session.token);
              }
              toast({
                title: "Empresa cadastrada",
                description: "Cadastro realizado com sucesso!",
                position: "top-right",
                status: "success",
                isClosable: true,
                containerStyle: {
                  fontSize: "14px",
                },
              });
              navigate("/");
              setIsLoading(false);
            })
            .catch((error) => {
              console.log("erro na gravação do usuario", error);
              setIsLoading(false);
            });
        })
        .catch((error) => {
          // console.log("erro na criação da empresa", error);
          setIsLoading(false);
          if (axios.isAxiosError(error)) {
            const axiosError = error as AxiosError<IErrorResponse>;
            if (axiosError.response) {
              const { message } = axiosError.response.data;
              if (message === "Register Found Email Company") {
                toast({
                  title: "Esse e-mail já está cadastrado na base",
                  description: "Utlize outro e-mail para prosseguir",
                  position: "top-right",
                  status: "error",
                  isClosable: true,
                  containerStyle: {
                    fontSize: "14px",
                  },
                });
              }
              if (message === "Register Found") {
                toast({
                  title: "Esse CPF/CNPJ já está cadastrado na base",
                  description: "Verifique ou use outro CPF/CNPJ",
                  position: "top-right",
                  status: "error",
                  isClosable: true,
                  containerStyle: {
                    fontSize: "14px",
                  },
                });
              }
            }
          }
        });

      // handleSetDetails(payloadCompany);
      // navigate("/");
    } catch (error) {
      console.log("Erro desconhcido", error);
      setIsLoading(false);
    }
  };

  const deselectApp = (app: IAplicativo) => {
    try {
      const newApps: IAplicativo[] = apps.map((item) => {
        if (item.aplicativoId === app.aplicativoId) {
          return {
            ...item,
            indAtivar: "N",
          };
        } else {
          return item;
        }
      });

      const appsActived = newApps.filter((item) => {
        if (item.indAtivar === "S") {
          return item.tag;
        }
      });
      setTags(appsActived.map((item) => item.tag));

      setApps(newApps);

      toast({
        title: "Aplicativo removido com Sucesso",
        position: "top",
        status: "success",
        isClosable: true,
      });
    } catch (error) {
      setIsOpenModalApp(false);
      toast({
        title: "Falha na gravação do banco de dados",
        position: "top",
        status: "error",
        isClosable: true,
      });
    }
  };

  const handleOpenModalNewApp = () => {
    setIsOpenModalNewApp(true);
  };

  useEffect(() => {
    if (!session.permissions.register) {
      navigate("/geral");
    }
  }, [navigate, session.permissions.register]);

  //2.01.009 -> Consome api de versões filtrando versões do unique e salva todos os dados em um array
  useEffect(() => {
    handleDataDefaultVersionUnique(session.token)
      .then((response) => {
        setDataVersionDefaultUnique(response);
      })
      .catch((error) => {
        console.log("Não foi possivel carregar versões do unique", error);
      });
  }, []);

  //2.01.009 -> Consome api de versões filtrando versões do gestor e salva todos os dados em um array
  useEffect(() => {
    handleDataDefaultVersionGestor(session.token)
      .then((response) => {
        setDataVersionDefaultGestor(response);
      })
      .catch((error) => {
        console.log("Não foi possivel carregar versões do gestor", error);
      });
  }, []);

  return (
    <Flex flexDir={"column"}>
      <Feedback />
      <HeaderLayout.Root>
        <HeaderLayout.Logo />
        <HeaderLayout.Content>
          <TitleRegisterCompany />
        </HeaderLayout.Content>
        <HeaderLayout.Logged />
      </HeaderLayout.Root>
      <Box
        as="form"
        onSubmit={handleSubmit(handleSaveCompany)}
        h={"full"}
        width={"820px"}
        margin={"0 auto"}
        pb={6}
        mt={5}
        px={4}
      >
        <HeaderInfo title="Dados da Empresa" />

        <Grid
          gridTemplateColumns={"repeat(6, minmax(0, 1fr))"}
          mt={4}
          gap={4}
          padding={1}
        >
          <GridItem colSpan={4}>
            <TextInput
              {...register("razao")}
              label="Nome / Razão Social"
              placeholder="Empresa teste"
              isRequired
            />
          </GridItem>
          <GridItem colSpan={2}>
            <TextInput
              {...register("cnpjcpf", {
                validate: validateCpfCnpj,
              })}
              label="CPF / CNPJ"
              placeholder="XX.XXX.XXX/XXXX-XX"
              error={errors.cnpjcpf}
              onInput={(e: React.ChangeEvent<HTMLInputElement>) =>
                (e.target.value = masked(e.target.value, "document"))
              }
              isRequired
            />
          </GridItem>
          <GridItem colSpan={4}>
            <TextInput
              {...register("responsavel")}
              label="Nome do Responsável (Contrato)"
              placeholder="Aroldo martins"
              isRequired
            />
          </GridItem>
          {/* <GridItem colSpan={2}>
              <Select
                {...register("indparceiro")}
                isDisabled={system === "gestor"}
                label="Parceiro Londrisoft"
                defaultValue={"0"}
              >
                <option value="0">Sem parceria</option>
                <option value="1">Iniciante</option>
                <option value="2">Prata</option>
                <option value="3">Ouro</option>
                <option value="4">Platina</option>
                <option value="5">Diamante</option>
              </Select>
            </GridItem> */}
          <GridItem colSpan={4}>
            <TextInput
              {...register("email")}
              label="E-mail"
              placeholder="mail@provider.com.br"
              isRequired
            />
          </GridItem>
          <GridItem colSpan={2}>
            <TextInput
              {...register("fone")}
              label="Telefone"
              placeholder="(XX) X XXXX-XXXX"
              onInput={(e: React.ChangeEvent<HTMLInputElement>) =>
                (e.target.value = masked(e.target.value, "phone"))
              }
              isRequired
            />
          </GridItem>
          <GridItem colSpan={1}>
            <TextInput
              {...register("cep")}
              label="Cep"
              placeholder="XXXXX-XXX"
              onChange={(e) => handleGetCep(e.target.value)}
              onInput={(e: React.ChangeEvent<HTMLInputElement>) =>
                (e.target.value = masked(e.target.value, "cep"))
              }
              isRequired
            />
          </GridItem>
          <GridItem colSpan={2}>
            <TextInput
              {...register("endereco")}
              label="Endereço"
              placeholder="Rua dos Bobos"
              isRequired
            />
          </GridItem>
          <GridItem colSpan={1}>
            <TextInput
              {...register("numero")}
              label="Número"
              placeholder="0"
              isRequired
            />
          </GridItem>
          <GridItem colSpan={2}>
            <TextInput
              {...register("bairro")}
              label="Bairro"
              placeholder="Igapo"
              isRequired
            />
          </GridItem>
          <GridItem colSpan={2}>
            <TextInput
              {...register("cidade")}
              label="Cidade / Município"
              placeholder="Londrina"
              isRequired
            />
          </GridItem>
          <GridItem colSpan={1}>
            <TextInput
              {...register("estado")}
              label="Estado"
              placeholder="Pr"
              isRequired
            />
          </GridItem>
        </Grid>

        {isLoading && (
          <Box
            h={"full"}
            display={"flex"}
            justifyContent={"center"}
            py={40}
            pt={"30vh"}
            position={"absolute"}
            left={0}
            right={0}
            top={0}
            bottom={0}
          >
            <Spinner
              thickness="4px"
              speed="0.65s"
              emptyColor="gray.200"
              color="blue.500"
              size="xl"
            />
          </Box>
        )}

        <HeaderInfo title="Aplicativos e Planos" mt={"30px"} />
        <Table size={"xs"} variant="striped">
          <Tbody>
            {apps.map((app) => {
              if (app.indAtivar === "S") {
                return (
                  <Tr key={app.aplicativoId}>
                    <Td
                      px={"15px"}
                      color={"#000"}
                      fontWeight={"bold"}
                      fontSize={"xs"}
                    >
                      {app.nome}
                    </Td>

                    <Td>
                      <Flex justifyContent={"end"}>
                        <Button
                          w="18px"
                          colorScheme="red"
                          variant={"ghost"}
                          leftIcon={<HiOutlineTrash size={"20px"} />}
                          onClick={() => deselectApp(app)}
                        ></Button>
                      </Flex>
                    </Td>
                  </Tr>
                );
              }
            })}
          </Tbody>
        </Table>

        <Flex justifyContent={"center"} mt={"20px"}>
          <Button
            variant={"ghost"}
            colorScheme={"blue"}
            border={"1px solid blue"}
            size={"sm"}
            leftIcon={<AiFillPlusCircle size={22} />}
            onClick={handleOpenModalNewApp}
          >
            Adicionar aplicativos
          </Button>
          {isOpenModalNewApp && (
            <AppsEcosystem
              propIsOpenModalNewApp={isOpenModalNewApp}
              propSetIsOpenModalNewApp={() => setIsOpenModalNewApp(false)}
              propSetTags={setTags}
              propSetApps={setApps}
              propApps={apps}
            />
          )}
        </Flex>

        <Flex gap={6} mt={5} justifyContent={"end"} alignItems="center">
          <Button
            onClick={() => setSystem(null)}
            w="160px"
            colorScheme={"gray"}
            variant={"link"}
            isDisabled={isSubmitting}
            type="button"
          >
            Voltar
          </Button>
          <Button
            type="submit"
            w="160px"
            colorScheme={"blue"}
            isLoading={isLoading}
            loadingText="Salvando..."
            disabled={apps.length < 1}
          >
            Salvar cadastro
          </Button>
        </Flex>
      </Box>
    </Flex>
  );
};
